import {
  __commonJS
} from "./chunk-BQWMX7FD.js";

// global-externals:jquery
var require_jquery = __commonJS({
  "global-externals:jquery"(exports, module) {
    module.exports = jQuery;
  }
});

export {
  require_jquery
};
//# sourceMappingURL=chunk-7WNYKQZ7.js.map
